import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../components/Forms/PresetsTextField'

const Comms = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <PresetsTextField
        fullWidth
        label="Command & Communications"
        suggestionPath="medPlan.commandCommunications"
        suggestionLabel="Command and comms from templates"
        setValue={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            commandCommunications: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        multiline
        InputLabelProps={{
          shrink: !!medPlan?.commandCommunications,
        }}
        value={medPlan?.commandCommunications}
      />
    </Grid>
  )
}

export default React.memo(Comms)
